import React, { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import { getActiveStep, selectActiveLayer, setActiveLayer } from "../../../../../../../redux/toolsSlice";
import { getLayerObjConfig, removeLayerConfig, setLayerConfig, updateLayer } from '../../../../../../../redux/stepsSlice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export const EmbedCodeLayerDefaults = (id) => {
  return {
    id: id,
    type: 'embedded_code',
    source: ''
  };
}

function EmbedCodeContent({ layer }) {
  const dispatch = useDispatch();
  const layerObjConfig = useSelector(
    (state) => getLayerObjConfig(state, layer),
    shallowEqual
  );
  const activeStep = useSelector((state) => getActiveStep(state));
  const stepId = activeStep.id;
  const activeLayer = useSelector((state) => selectActiveLayer(state));

  const defaultConfig = [
    {
      layerId: layer.id,
      sectionId: 'embedded_code',
      sectionTitle: 'Embed Element',
      values: [
        {
          id: 'source',
          title: 'Embed Code',
          type: 'textarea',
          value: layer.source || '',
          direction: 'column'
        }
      ]
    }
  ];

  const editElement = () => {
    removeFocusElement();
    dispatch(setActiveLayer(layer));
    dispatch(setLayerConfig(defaultConfig));
  }

  const removeFocusElement = () => {
    dispatch(setActiveLayer({}));
    dispatch(removeLayerConfig());
  }

  const handleSourceChange = (e) => {
    setSource(e.target.value);
  }

  useEffect(() => {
    if (layerObjConfig) {
      const newLayer = {
        ...layer,
        ...layerObjConfig
      };
      dispatch(updateLayer({ stepId: stepId, layer: newLayer }));
    }
  }, [layerObjConfig]);

  return (
    <div className='video-wrapper'>
      {layer.source ?
        <EmbedCodeContentPreview onClick={editElement} layer={layer} />
      :
        <div className="un-pe-drop" tabIndex={0} onClick={editElement}>
          <span className="un-pe-drop__i">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="m8 8-4 4 4 4M16 8l4 4-4 4" stroke="#028496" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
          <div className="un-pe-drop__t">Paste embed or HTML code</div>
        </div>
      }
    </div>
  )
}

export const EmbedCodeContentPreview = memo(({layer, onClick}) => {
  const elRef = useRef();

  useLayoutEffect(() => {
		const range = document.createRange();
		range.selectNode(elRef.current);
		const documentFragment = range.createContextualFragment(layer.source);
		elRef.current.innerHTML = '';
		elRef.current.append(documentFragment);
	}, []);

  const heightMatch = String(layer?.height || '').match(/\d+/);
  const minHeight = heightMatch ? `${heightMatch[0]}px` : undefined;
  const inset = layer?.embedAlign === 'inset';

  return(
    <div
      ref={elRef}
      tabIndex={0}
      onClick={onClick}
      style={{ minHeight, width: inset ? '70%' : '100%', maxWidth: '100%', margin: inset ? '0 auto' : undefined }}
    />
  )
});

export default EmbedCodeContent;